interface PlanningIconProps {
  size?: number;
  strokeWidth?: number;
  className?: string;
  style?: React.CSSProperties;
}

export function PlanningIcon({ size = 24, strokeWidth = 2, className, style }: PlanningIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
      <line x1="3" y1="9" x2="21" y2="9" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" />
      <line x1="7" y1="3" x2="7" y2="7" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" />
      <line x1="17" y1="3" x2="17" y2="7" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" />
      <circle cx="6" cy="12" r="0.75" fill="currentColor" />
      <circle cx="9" cy="12" r="0.75" fill="currentColor" />
      <circle cx="12" cy="12" r="0.75" fill="currentColor" />
      <circle cx="15" cy="12" r="0.75" fill="currentColor" />
      <circle cx="18" cy="12" r="0.75" fill="currentColor" />
      <circle cx="6" cy="15" r="0.75" fill="currentColor" />
      <circle cx="9" cy="15" r="0.75" fill="currentColor" />
      <circle cx="12" cy="15" r="0.75" fill="currentColor" />
      <circle cx="15" cy="15" r="0.75" fill="currentColor" />
      <circle cx="18" cy="15" r="0.75" fill="currentColor" />
      <circle cx="6" cy="18" r="0.75" fill="currentColor" />
      <circle cx="9" cy="18" r="0.75" fill="currentColor" />
      <circle cx="12" cy="18" r="0.75" fill="currentColor" />
      <circle cx="15" cy="18" r="0.75" fill="currentColor" />
      <circle cx="18" cy="18" r="0.75" fill="currentColor" />
    </svg>
  );
}
